function Skeleton() {
  return <div className="rounded animate-pulse-quick h-96 w-full bg-palette-color-border" />;
}

export default Skeleton;
